import React from 'react';
import { makeStyles } from '@mui/styles';

/**
 * @param {Object} props
 * @param {Node} props.children
 * @param {Number} [props.height]
 * @param {Boolean} [props.rtl]
 * @param {Boolean} [props.ltr]
 * @param {Boolean} [props.center]
 * @param {Object} [props.style]
 * @param {String} [props.className]
 * @param {Number|String} [props.spacing]
 * @param {'nowrap'|'wrap'|'wrap-reverse'} [props.wrap]
 */
function RowLayout({
    children,
    height,
    rtl,
    ltr,
    center,
    style,
    className,
    spacing,
    wrap='wrap',
    addSeparator = false,
    ...rest
}) {
    let direction;
    if (rtl) {
        direction = "rtl";
    } else if (ltr) {
        direction = "ltr";
    } else {
        direction = "ltr"; // Default
    }

    const classes = useStyles({direction, center, wrap});

    const childrenCount = React.Children.count(children);

    return (
        <div className={className} style={{ height, ...style }}>
            <div className={classes.root} {...rest}>
                {
                    React.Children.map(children, (child, index) => (
                        <React.Fragment key={index}>
                            <div className={"centerContent"}>
                                { child }
                                {index!== childrenCount && addSeparator && <rowSaperator/>}
                            </div>
                            {
                                spacing && (index !== childrenCount) && <span style={{ width: spacing, display: 'inline-block' }} />
                            }
                        </React.Fragment>
                    ))
                }
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        alignContent: 'stretch',
        direction: props => props.direction,
        justifyContent: props => props.center ? "center" : undefined,
        height: '100%',
        flexWrap: props => props.wrap,
        width: '100%'
    },
    child: {
        height: '100%'
    }
})

export default React.memo(RowLayout);